import React, { useImperativeHandle, forwardRef, useRef } from 'react';
import { useRefresh, useNotify } from 'react-admin';

import { DialogoConfirmacao } from '../../../Components';
import { api } from '../../../services';

const FormDialog = forwardRef((props, ref) => {
  const refresh = useRefresh();
  const refDialogoConfirmacao = useRef(null);

  useImperativeHandle(ref, () => ({
    handleOpen(record) {
      if (refDialogoConfirmacao.current) {
        refDialogoConfirmacao.current.handleOpen(
          !record.is_ruptura
            ? 'Marcar como em ruptura'
            : 'Desmarcar como em ruptura',
          !record.is_ruptura
            ? 'Marcar como em ruptura'
            : 'Desmarcar como em ruptura',
          record,
        );
      }
    },
  }));

  async function handleConfirma(record) {
    await api.put(`/${'produtos-change-ruptura'}/${record.id}`);
    refresh();
  }

  return (
    <DialogoConfirmacao
      ref={refDialogoConfirmacao}
      handleConfirma={handleConfirma}
    />
  );
});

export default FormDialog;
